import React from 'react';
import { Check, ChevronDown } from 'lucide-react';
import styled from '../../styled';
import { DEMO_CAMPAIGNS } from '../../constants/demo-copy';
import { COLORS } from '../../themes/color';
import {
  AppMockupChrome,
  ProductMockupBody,
  ProductMockupFrame
} from './shared';

const StepRow = styled('div')`
  display: flex;
  gap: 10px;
  align-items: flex-start;
`;

const StepBadge = styled('div')`
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: ${COLORS.PRIMARY};
`;

const StepContent = styled('div')`
  flex: 1;
  min-width: 0;
`;

const StepTitle = styled('div')`
  font-size: 13px;
  font-weight: 600;
  color: #0e1c2b;
  margin-bottom: 10px;
`;

const CampaignCard = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border: 1px solid #d4e0ff;
  border-radius: 10px;
  padding: 14px 16px;
`;

const CampaignIcon = styled('div')`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #7b0051;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
`;

const CampaignInfo = styled('div')`
  flex: 1;
  min-width: 0;

  .name {
    font-size: 13px;
    font-weight: 700;
    color: #0e1c2b;
  }

  .dates {
    font-size: 11px;
    color: #64748b;
    margin-top: 2px;
  }
`;

const CampaignActions = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
`;

const RunningPill = styled('span')`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  color: #389e0d;
  background: #f6ffed;
  border-radius: 100px;
  padding: 3px 10px;

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #52c41a;
  }
`;

const FooterRow = styled('div')`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #f1f5f9;
`;

const GenerateButton = styled('div')`
  font-size: 13px;
  font-weight: 600;
  color: #0e1c2b;
  background: #cbd5e1;
  border-radius: 8px;
  padding: 9px 18px;
`;

export const LinkGeneratorMockup = () => (
  <ProductMockupFrame>
    <AppMockupChrome product="Amplify" surface="Link generator" />
    <ProductMockupBody style={{ background: '#fff' }}>
      <StepRow>
        <StepBadge>
          <Check size={12} />
        </StepBadge>
        <StepContent>
          <StepTitle>Campaign to connect with link</StepTitle>
          <CampaignCard>
            <CampaignIcon>W</CampaignIcon>
            <CampaignInfo>
              <div className="name">{DEMO_CAMPAIGNS.homeRefresh} - Oct – Dec 2026</div>
              <div className="dates">Oct 1 – Dec 31</div>
            </CampaignInfo>
            <CampaignActions>
              <RunningPill>Running</RunningPill>
              <ChevronDown size={14} color="#64748b" />
            </CampaignActions>
          </CampaignCard>
        </StepContent>
      </StepRow>

      <FooterRow>
        <GenerateButton>Generate links</GenerateButton>
      </FooterRow>
    </ProductMockupBody>
  </ProductMockupFrame>
);
